import script from "./CustomResourceApplyDX.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyDX.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyDX.vue?vue&type=style&index=0&id=64af6a39&lang=less&scope=true"

const __exports__ = script;

export default __exports__